var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filters.length)?_c('div',{class:'vlFilters'+_vm.placement},[_vm._l((_vm.filters),function(filter){return [_c(_vm.$_vueTag(filter),{tag:"component",attrs:{"vkompo":filter,"kompoid":_vm.kompoid}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }